module.exports = __webpack_public_path__ + "fonts/VistaSansOT-Book.c0d0393b.otf";